import { useLocalization } from "@fluent/react";
import { Dialog } from "cerulean";

import styles from "./ReceiptPreviewOverlay.module.scss";

interface ReceiptPreviewOverlayProps {
  receipt: API.TransactionReceipt | null;
  onClose: () => void;
}

const ReceiptPreviewOverlay = ({
  receipt,
  onClose,
}: ReceiptPreviewOverlayProps) => {
  const { l10n } = useLocalization();

  return (
    <Dialog
      isOpen={Boolean(receipt)}
      title={receipt?.original_filename ?? ""}
      headerStyle="bordered"
      width="min(900px, 90vw)"
      onUserDismiss={onClose}
      testId="ledger-receipt-preview"
    >
      {receipt?.thumbnail_url ? (
        <img
          src={receipt.thumbnail_url}
          alt={receipt.original_filename}
          className={styles.previewImage}
          data-testid="ledger-receipt-preview-image"
        />
      ) : (
        <p
          className="fontColor--secondary"
          data-testid="ledger-receipt-preview-pending"
        >
          {l10n.getString("live-ledger-receipt-preview-unavailable")}
        </p>
      )}
    </Dialog>
  );
};

export default ReceiptPreviewOverlay;
